import { ClientPlatform } from '../../types';

export const pollHeaders = (clientPlatform: ClientPlatform | undefined) => ({
  'Content-Type': 'application/json',
  ...(clientPlatform && {
    'Client-Platform-Class': clientPlatform.class,
    'Client-Platform': clientPlatform.name,
    'Client-Platform-Audience': clientPlatform.audience,
    'Client-Platform-AppVersion': clientPlatform.version,
  }),
});
